import { createAsyncThunk, AsyncThunk } from '@reduxjs/toolkit';
import { basicApiAsyncThunkCreator } from '../../../services/apiAsyncThunkCreator';
import { ThunkAPI } from '../../rootReducer';
import { showSuccessMessage, showErrorMessage } from '../../notifications';
import { SERVICES, HttpMethods } from '../../../services/api';
import { Ifilter } from '../../../components/common/filters/interfaces';
import { ListBulkParams } from '../../utils';

export const updateAccountActiveStatusBulk: AsyncThunk<void, ListBulkParams<Ifilter[]>, ThunkAPI> = createAsyncThunk(
  'accounts/bulk/update-active-status',
  async (params: ListBulkParams<Ifilter[]>, thunk) => {
    try {
      const response = await basicApiAsyncThunkCreator<void, ListBulkParams<Ifilter[]>>({
        endpoint: 'accounts/bulk/update-active-status',
        microservice: SERVICES.USERS_SERVICE,
        authenticated: true,
        method: HttpMethods.Post,
        contentType: 'application/json'
      })(params, thunk);

      thunk.dispatch(showSuccessMessage('update status Accounts successfully'));
      return response;
    } catch(err) {
      thunk.dispatch(showErrorMessage(typeof err === 'string' ? err : 'Unknown Error'));
      return thunk.rejectWithValue(err);
    }
  }
);
